import { get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import { createChangeTableSettingAction } from '../../../form/state/table-state-helper'
import * as tableAction from "../../../table/state/action";

export const changeTableSetting = createChangeTableSettingAction(type.CHANGE_TABLE_SETTINGS)


export const findUnassignedPaymentListRequest = () => ({
    type: type.FIND_UNASSIGNED_PAYMENT_LIST_REQUEST,
})

export const findUnassignedPaymentListSuccess = (paymentList) => ({
    type: type.FIND_UNASSIGNED_PAYMENT_LIST_SUCCESS,
    payload: {
        paymentList,
    },
})

export const findUnassignedPaymentListError = (error) => ({
    type: type.FIND_UNASSIGNED_PAYMENT_LIST_ERROR,
    payload: {
        error,
    },
})


export const findUnassignedPaymentList = () => (dispatch, getState) => {
    dispatch(findUnassignedPaymentListRequest())

    get('/api/payment/get-unassigned-payments')
        .then(paymentList => {
            dispatch(findUnassignedPaymentListSuccess(paymentList))
        })
        .catch(error => {
            dispatch(findUnassignedPaymentListError(error))
        })
}

export const editUnassignedPayment = (payment) => ({
    type: type.EDIT_UNASSIGNED_PAYMENT,
    payload: {
        payment,
    },
})

export const changeCustomer = (customer) => ({
    type: type.CHANGE_CUSTOMER,
    payload: {
        customer,
    },
})

export const changeSalesOrder = (name, value) => ({
    type: type.CHANGE_SALES_ORDER,
    payload: {
        name, value,
    },
})


export const associatePaymentRequest = () => ({
    type: type.ASSOCIATE_PAYMENT_REQUEST,
})

export const associatePaymentSuccess = (paymentList) => ({
    type: type.ASSOCIATE_PAYMENT_SUCCESS,
    payload: {
        paymentList,
    },
})

export const associatePaymentError = (error) => ({
    type: type.ASSOCIATE_PAYMENT_ERROR,
    payload: {
        error,
    },
})

export const associatePayment = () => (dispatch, getState) => {
    const state = getState()
    const payment = selector.selectCurrentPayment(state)

    if (!payment.customerId || !payment.salesOrderId) {
        return
    }

    dispatch(associatePaymentRequest())


    post('/api/payment/associate-payment', payment)
        .then(paymentList => {
            window.scrollTo(0, 0)
            dispatch(associatePaymentSuccess(paymentList))
        })
        .catch(error => {
            dispatch(associatePaymentError(error))
        })
}

export const deletePaymentRequest = () => ({
    type: type.DELETE_PAYMENT_REQUEST,
})

export const deletePaymentSuccess = (paymentList) => ({
    type: type.DELETE_PAYMENT_SUCCESS,
    payload: {
        paymentList,
    },
})

export const deletePaymentError = (error) => ({
    type: type.DELETE_PAYMENT_ERROR,
    payload: {
        error,
    },
})

export const initialColumnsVisibility = tableAction.createInitialColumnsVisibilityFormHandler(type.TABLE_ASSOCIATE_PAYMENTS, type.CHANGE_TABLE_SETTINGS)

export const toggleColumnVisibility = tableAction.createToggleColumnVisibilityFormHandler(selector.selectOwnState, type.CHANGE_TABLE_SETTINGS, type.TABLE_ASSOCIATE_PAYMENTS)

export const deletePayment = () => (dispatch, getState) => {
    const state = getState()
    const payment = selector.selectCurrentPayment(state)

    dispatch(deletePaymentRequest())

    get('/api/payment/delete?paymentId=' + payment.id)
        .then(paymentList => {
            window.scrollTo(0, 0)
            dispatch(deletePaymentSuccess(paymentList))
        })
        .catch(error => {
            dispatch(deletePaymentError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/payment/state/associate-payment/action.js